define([
    "./monitoringTemperatureOverviewModule",
    "./monitoringTemperatureOverviewController"
], function () {
});
